<template>
  <div>
    <div>
      <h2 class="text-3xl font-bold">
        Automations
      </h2>
    </div>
    
    <div class="mt-5 divide-y card">
      <div class="grid grid-cols-1 divide-y md:divide-y-0 md:divide-x md:grid-cols-3">
        <div class="flex items-center px-4 py-5 sm:p-6">
          <div class="flex items-center justify-center flex-shrink-0 w-12 h-12 text-white bg-indigo-500 rounded-md">
            <fa :icon="['far', 'signal-stream']" size="lg" fixed-width />
          </div>
          <div class="flex-1 w-0 ml-5">
            <dl>
              <dt class="text-xs font-medium tracking-wider text-gray-500 uppercase truncate">
                Events Tracked
              </dt>
              <dd class="flex items-baseline">
                <div class="text-2xl font-semibold leading-8 text-gray-900">
                  71,897
                </div>
              </dd>
            </dl>
          </div>
        </div>
        <div class="flex items-center px-4 py-5 sm:p-6">
          <div class="flex items-center justify-center flex-shrink-0 w-12 h-12 text-white bg-indigo-500 rounded-md">
            <fa :icon="['far', 'sync']" size="lg" fixed-width />
          </div>
          <div class="flex-1 w-0 ml-5">
            <dl>
              <dt class="text-xs font-medium tracking-wider text-gray-500 uppercase truncate">
                Automations Run
              </dt>
              <dd class="flex items-baseline">
                <div class="text-2xl font-semibold leading-8 text-gray-900">
                  586
                </div>
              </dd>
            </dl>
          </div>
        </div>
        <div class="flex items-center px-4 py-5 sm:p-6">
          <div class="flex items-center justify-center flex-shrink-0 w-12 h-12 text-white bg-indigo-500 rounded-md">
            <fa :icon="['far', 'car-alt']" size="lg" fixed-width />
          </div>
          <div class="flex-1 w-0 ml-5">
            <dl>
              <dt class="text-xs font-medium tracking-wider text-gray-500 uppercase truncate">
                Automations Per Vehicle
              </dt>
              <dd class="flex items-baseline">
                <div class="text-2xl font-semibold leading-8 text-gray-900">
                  24.57
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div>
        <sparkbar color="#6775F5" :series="series" start="31 Aug 2020" end="05 Sep 2020" />
      </div>
    </div>

  </div>
</template>

<script>
import Sparkbar from '@/components/Sparkbar'

export default {
  name: 'OverviewAutomations',

  components: {
    Sparkbar
  },

  data () {
    return {
      series: [{
        name: 'Automations',
        data: [
          11, 16, 26, 32, 12, 18, 12, 45, 32, 11, 16, 26, 32, 12, 18, 12, 45, 32, 11, 16, 26, 32, 12, 18,
          11, 16, 26, 32, 12, 18, 3, 11, 16, 26, 32, 12, 18, 12, 45, 32, 11, 16, 26, 32, 12, 18, 45, 32, 
          11, 11, 2, 12, 18, 12, 45, 26, 32, 12, 18, 12, 7, 45, 32, 11, 16, 26, 32, 12, 18, 12, 16, 26, 
          32, 12, 18, 32, 11, 16, 26, 32, 18, 12, 45, 32, 11, 16, 26, 32, 11, 16, 26, 32, 12, 18, 12, 45, 
          32, 32, 11, 16, 5, 32, 12, 18, 12, 45, 32, 11, 16, 26, 32, 12, 18, 11, 16, 26, 32, 12, 18, 12, 
          45, 32, 11, 16, 26, 32, 12, 18, 11, 16, 26, 8, 12, 18, 12, 45, 32, 11, 16, 26, 32, 12, 12, 18,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }]
    }
  }
}
</script>